import { useStandardsModalContext } from "@/search/NewSearchPageMVP/provider/StandardsModalProvider";
import { StandardsSetsHeader } from "../../shared/StandardsSetsHeader";
import { StandardsSetsTitleInput } from "../../shared/StandardsSetsTitleInput";
import { StandardsList } from "../../shared/StandardsList";
import { StandardsLoadingSpinner } from "../../shared/StandardsLoadingSpinner";
import { SelectedStandardsInSet } from "../../shared/SelectedStandardsInSet";

import {
  selectedChipsCss,
  titleContainerCss,
} from "./CreateStandardsSets.styles";

export const CreateStandardsSets = () => {
  const {
    getters: {
      draftStandardsSetId,
      newStandardsSet: { children: standardsInNewSet },
    },
  } = useStandardsModalContext();

  return (
    <StandardsLoadingSpinner waitForAPI apiFlag={draftStandardsSetId === ""}>
      <StandardsSetsHeader />
      <div css={titleContainerCss}>
        <StandardsSetsTitleInput />
      </div>
      <div css={selectedChipsCss}>
        {!!standardsInNewSet.length && <SelectedStandardsInSet />}
      </div>
      <StandardsList />
    </StandardsLoadingSpinner>
  );
};
